module.exports = __webpack_public_path__ + "static/img/ins.84720a15.png";